class ContentBanner extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    window.loadSwiper.then((swiperLib) => {
      this.swiperLib = swiperLib;

      this._initCarousel();
    });
  }

  disconnectedCallback() {}

  _initCarousel() {
    const { Swiper, Pagination, Autoplay } = this.swiperLib;

    let autoplay = false;

    if (this.hasAttribute("delay")) {
      autoplay = {
        delay: parseInt(this.getAttribute("delay")),
        disableOnInteraction: true,
      };
    }

    const swiperParams = {
      modules: [Pagination, Autoplay],
      slidesPerView: "auto",
      autoplay,
      speed: 300,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: this.querySelector("[data-navigation-next]"),
        prevEl: this.querySelector("[data-navigation-previous]"),
      },
    };

    this.swiper = new Swiper(this, swiperParams);
    this.lastSlide = this.swiper.slides[0];

    this.swiper.on("slideChange", () => {
      this.lastSlide
        .querySelector("video-snippet")
        ?.dispatchEvent(new CustomEvent("video-snippet:pause"));

      const currentSlide = this.swiper.slides[this.swiper.activeIndex];
      currentSlide
        .querySelector("video-snippet")
        ?.dispatchEvent(new CustomEvent("video-snippet:play"));

      this.lastSlide = currentSlide;
    });
  }
}

if (!customElements.get("content-banner")) {
  customElements.define("content-banner", ContentBanner);
}
